
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult } from "@tylertech/tyler-api-types";

/**
 * ModuleControlService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ModuleControlService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetSettings(): Promise<ExecutionResult<{ [key: string]: any }>> {
        return this.$apiService.sendAuth("IModuleControlService/GetSettings");
    }
}
